import React, { Component } from "react";
import Slider11 from "../assests/Slider11.jpg";
import Slider12 from "../assests/Slider12.jpg";
import Slider13 from "../assests/Slider13.jpg";
import "../styles/Home.css";

export default class Home extends Component {
  render() {
    return (
      <div id="home">
        <div className="container text-center py-3">
          <h1>Welcome to Fashion Flair World</h1>
          <p className="text-muted">
            Discover a world where fashion meets passion. At Fashion Flair
            World, we redefine style with timeless elegance, trendsetting
            designs, and curated collections that inspire confidence in every
            step you take.
          </p>
        </div>

        {/* ⬇️ Carousel inside container for side spacing */}
        <div className="container my-4">
          <div
            id="carouselExampleCaptions"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-indicators">
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" />
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2" />
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3" />
            </div>

            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={Slider11} className="d-block w-100" alt="First slide" style={{ height: "500px", objectFit: "cover" }} />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Elevate Every Corner of Your Home</h5>
                  <p>
                    From plush cushions to statement curtains, our home furnishing
                    collection adds warmth and personality to your space. Discover
                    cozy textures and timeless designs that turn your house into a
                    home — effortlessly stylish and deeply comforting.
                  </p>
                </div>
              </div>

              <div className="carousel-item">
                <img src={Slider12} className="d-block w-100" alt="Second slide" style={{ height: "500px", objectFit: "cover" }} />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Finish Your Look with Flair</h5>
                  <p>
                    Accessorize with intention. From elegant earrings to handcrafted bags,
                    our curated accessories are made to express your unique vibe. Because
                    the right accessory doesn’t just complete an outfit — it tells a story.
                  </p>
                </div>
              </div>

              <div className="carousel-item">
                <img src={Slider13} className="d-block w-100" alt="Third slide" style={{ height: "500px", objectFit: "cover" }} />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Tailored Elegance, Just for You</h5>
                  <p>
                    Experience the art of personalized fashion with our customized
                    dresses — where your vision meets skilled craftsmanship.
                    Whether it's casual chic or bridal glam, we stitch your story
                    into every seam. Because your style deserves a perfect fit.
                  </p>
                </div>
              </div>
            </div>

            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
